import { DomainConfig } from '@domgen/dgx-fe-config';
import { AppDomainFeatures } from './app-domain-features.type';

export interface AppDomainConfig extends DomainConfig {
  canonicalBaseUrl: string;
  domainFeatures: AppDomainFeatures;
}
